import type { AvatarProps } from '../avatar'
import type { MessageProps } from '../message'

import { Avatar } from '../avatar'
import { Box } from '../box'
import { useStyleConfig, vui } from '../core'
import { MessageBase } from '../message'
import { cs } from '../utils'

type ChatMessageProps = MessageProps & {
  avatar?: AvatarProps
}

const defaultAvatar: AvatarProps = {
  variant: 'solidDarkBlue',
  icon: 'brandVeracity',
}

/**
 * Displays a chat interface with messages and actions.
 */
export const ChatMessage = vui<'div', ChatMessageProps>((props, ref) => {
  const styles = useStyleConfig('Chat', props)
  const { avatar = defaultAvatar, children, text, intent: _intent, size: _size, ...rest } = props

  return (
    <MessageBase
      className={cs('vui-chat-message')}
      display="flex"
      h="100%"
      my="16px"
      ref={ref}
      {...styles?.message}
      {...rest}
    >
      <Avatar mr="16px" {...avatar} />
      <Box color="black" mt="4px" w="100%">
        {children ?? text}
      </Box>
    </MessageBase>
  )
})

ChatMessage.displayName = 'ChatMessage'
export default ChatMessage
